/*
 * @Author: Han
 * @Date: 2022-05-10 16:12:23
 * @LastEditors: Han
 * @LastEditTime: 2022-05-10 18:01:52
 * @FilePath: \czssj-h5\h5\src\http\api.js
 */
import * as home from './moudules/home'
import * as classSituation from './moudules/classSituation'
import * as homework from './moudules/homework'
import * as growthPoint from './moudules/growthPoint'
import * as perfectRegis from './moudules/perfectRegis'

/* 
 * 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */
// 默认全部导出
export default {
  home,
  classSituation,
  growthPoint,
  homework,
  perfectRegis
}



// WEBPACK FOOTER //
// ./src/http/api.js